import React from 'react';
import { withRouter } from 'react-router';

import './dockedMenu.scss';

class DockedMenu extends React.Component {
    state = { isOverlayToggled: false, isWindowDisplayed: false }
    origin = {
        'left': {
            overlay: () => {
                return {
                    right: this.state.isOverlayToggled ? 0 : `${window.innerWidth}px`,
                    backgroundColor: this.state.isWindowDisplayed ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)',
                    display: this.props.isToggled ? 'block' : this.state.isOverlayToggled ? 'block' : 'none'
                }
            },
            window: () => {
                return {
                    right: this.state.isWindowDisplayed ? '20%' : `${window.innerWidth}px`,
                    display: this.props.isToggled ? 'block' : this.state.isOverlayToggled ? 'block' : 'none'
                }
            }
        },
        'right': {
            overlay: () => {
                return {
                    left: this.state.isOverlayToggled ? 0 : `${window.innerWidth}px`,
                    backgroundColor: this.state.isWindowDisplayed ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)',
                    display: this.props.isToggled ? 'block' : this.state.isOverlayToggled ? 'block' : 'none'
                }
            },
            window: () => {
                return {
                    left: this.state.isWindowDisplayed ? '20%' : `${window.innerWidth}px`,
                    display: this.props.isToggled ? 'block' : this.state.isOverlayToggled ? 'block' : 'none'
                }
            }
        }
    }
    timer = null;

    componentDidUpdate(prevProps) {
        if (prevProps.isToggled !== this.props.isToggled) {
            this.setState({ isWindowDisplayed: this.props.isToggled }, () => {
                clearTimeout(this.timer);
                if (this.props.isToggled) {
                    this.setState({ isOverlayToggled: true });
                } else {
                    this.timer = setTimeout(() => this.setState({ isOverlayToggled: false }), 500);
                }
            })
        }
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.props.isToggled && this.props.hideDockedMenu();
        }
    }

    render() {
        return (<>
            <div className='docked-menu-overlay hide-on-desktop'
                style={this.origin[this.props.isLeft === true ? 'left' : 'right'].overlay()}
                onClick={_ => this.props.hideDockedMenu()} />
            <div className='docked-menu hide-on-desktop'
                style={this.origin[this.props.isLeft === true ? 'left' : 'right'].window()}>
                {this.props.children}
            </div>
        </>)
    }
}

export default withRouter(DockedMenu);